/**
 * @author EdenCha <eden@nurigo.net>
 */
import React, { Component } from 'react'
import qs from 'querystring'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { matchPath } from 'react-router'
import autoBind from 'react-autobind'

// import components
import AppList from 'components/organisms/AppList'
import AppDetailContainer from 'containers/AppDetailContainer'

import { actions as appstoreActions } from 'store/modules/appstore'
import { bindStateToProps, bindActionCreators } from 'lib'

class AppListContainer extends Component {
  constructor(props) {
    super(props)
    autoBind(this)
    this.state = {}
  }

  async componentDidMount() {
    window.onpopstate = this.onPopState
    const { AppstoreActions, location } = this.props
    const params = qs.parse(location.search.replace(/^\?/, ''))
    const searchParams = Object.assign(
      {},
      ...Object.keys(params)
        .filter(key => {
          return !!params[key]
        })
        .map(key => ({ [key]: params[key] }))
    )
    AppstoreActions.getAppList(searchParams)
    // appId가 존재하는 경우 디테일 페이지로 이동
    const appId = this.getCurrentAppId()
    if (appId) {
      AppstoreActions.getAppData(appId)
      return AppstoreActions.setState({ appId, detailPage: true })
    }
    AppstoreActions.setState({ appId, detailPage: false })
  }

  onPopState = e => {
    e.preventDefault()
    const { AppstoreActions } = this.props
    const appId = this.getCurrentAppId()
    const state = e.state || {}
    const { state: { appId: stateAppId } = {} } = state
    AppstoreActions.setState({
      appId,
      detailPage: !!appId,
      appDetailPopup: appId && stateAppId
    })
  }

  onOpenAppDetailPopup = (e, appId) => {
    e.preventDefault()
    const { history, AppstoreActions } = this.props
    history.push(`/apps/${appId}`, { appId })
    AppstoreActions.getAppData(appId)
    AppstoreActions.setState({ appDetailPopup: true })
  }

  onCloseAppDetailPopup = e => {
    const { history, AppstoreActions } = this.props
    history.goBack()
    AppstoreActions.setState({ appDetailPopup: false })
  }

  onClickLoadMoreBtn = () => {
    const { AppstoreActions, appList = [], appListSearchParams } = this.props
    const params = Object.assign(appListSearchParams, {
      offset: appList.length
    })
    AppstoreActions.addAppList(params)
  }

  getProps(props) {
    return Object.assign(
      {},
      ...props.map(prop => {
        return { [prop]: this[prop] }
      })
    )
  }

  getCurrentAppId() {
    const { history } = this.props
    const { params: { appId } = {} } =
      matchPath(history.location.pathname, {
        path: '/apps/:appId',
        exact: true,
        strict: false
      }) || {}
    return appId
  }

  render() {
    const thisProps = `
      onOpenAppDetailPopup
      onCloseAppDetailPopup
      onClickLoadMoreBtn
    `
      .replace(/\n|\s/g, ',')
      .split(',')
    const props = Object.assign(
      {},
      this.props,
      this.state,
      this.getProps(thisProps.filter(d => d))
    )
    if (
      this.props.detailPage === undefined &&
      this.props.appDetailPopup === undefined
    ) {
      return null
    }
    if (this.props.detailPage && !this.props.appDetailPopup) {
      return <AppDetailContainer />
    }
    return <AppList {...props} />
  }
}

export default connect(
  bindStateToProps({
    appstore: [
      'appId',
      'detailPage',
      'appDetailPopup',
      'appListLoading',
      'appList',
      'appListHasNext',
      'appListSearchParams'
    ]
  }),
  bindActionCreators({ appstoreActions })
)(withRouter(AppListContainer))
